export const ROLE_SELECTION_SHOW = "ROLE_SELECTION_SHOW";
export const ROLE_SELECTION_HIDE = "ROLE_SELECTION_HIDE";

export const showRoleSelectionModal = () => ({
  type: ROLE_SELECTION_SHOW,
});

export const hideRoleSelectionModal = () => ({
  type: ROLE_SELECTION_HIDE,
});
